import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import LinkButton from "../utils/LinkButton";
import { useSearchParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { scrollToContent, overlayButtonStyle } from "../../../utils/layout";

function SimpleResourceItems(props) {
    const [xframe, setXframe] = useState();
    const [file, setFile] = useState("");

    useEffect(() => {
        if(xframe){
            scrollToContent();
        }
    },[xframe])

    const SetItems = (item) => {
        console.log(item)
        setXframe(true)
        if(item.file !== null && item.file !== undefined){
            setFile(item.file)
        }else{
            setFile(item.url)
        }
        
    }
  return (
    xframe ? (
        <>
        <Button
            style={{
                ...overlayButtonStyle(props.overlayRow),
                backgroundColor: props.backgroundC,
                color: props.fontColor,
                border: props.borderC,
            }}
            onClick={() => setXframe()}
        >
            Select a new Resource
        </Button>
        <div style={{display: 'flex', height: window.innerHeight}}>
            <main style={{ flex: 1, backgroundColor: 'lightgray' }}>
            <embed width="100%" height="100%" src={file} />
            </main>
        </div>
        </>
    ) : (<Container>
        <Col>
            {/* {r && <Row key={'kdng_4000'} style={{ marginTop: "25px" }}>
                            <Card
                            style={{ padding: "5px" }}
                            >
                            <LinkButton
                                buttonWidth="100%"
                                buttonHeight="88px"
                                buttonFontSize="26px"
                                url={'https://anynamegen.com/gen/kentucky-derby-name-generator-2021_827/'}
                                newTab={true}
                                title={"Kentucky Derby Name Generator"}
                            />
                            </Card>
                        </Row>} */}
            {props.items.map((item) => {
            return (
                <Row key={item.id} style={{ marginTop: "25px" }}>
                <Card
                    onClick={() => SetItems(item)}
                    style={
                      props.backgroundC
                        ? { padding: "5px", background: "none", border: "none" }
                        : { padding: "5px" }
                    }
                >
                    <LinkButton
                    buttonWidth="100%"
                    buttonHeight="88px"
                    buttonFontSize="26px"
                    title={item.name}
                    backgroundColor={props.backgroundC}
                    fontColor={props.fontColor}
                    border={props.borderC}
                    />
                </Card>
                </Row>
            );
            })}
        </Col>
    </Container>)
  )
}

export default SimpleResourceItems